// src/modules/agents/api.js
import API from '../../services/api';

export const fetchAgents = ({ search = '', page = 1, limit = 50, status = '', branch = '' } = {}) =>
  API.get('/agents', {
    params: { search, page, limit, ...(status ? { status } : {}), ...(branch ? { branch } : {}) },
  }).then((r) => r.data);

export const getAgentById = (id) =>
  API.get(`/agents/${id}`).then((r) => r.data);

export const createAgent = (data) =>
  API.post('/agents', data).then((r) => r.data);

export const updateAgent = (id, data) =>
  API.put(`/agents/${id}`, data).then((r) => r.data);

export const getAgentCommissions = (id, params = {}) =>
  API.get(`/agents/${id}/commissions`, { params }).then((r) => r.data);

export const getAllCommissions = (params = {}) =>
  API.get('/agents/commissions/all', { params }).then((r) => r.data);

export const markCommissionPaid = (commissionId, data) =>
  API.patch(`/agents/commissions/${commissionId}/pay`, data).then((r) => r.data);

export const bulkMarkCommissionsPaid = (data) =>
  API.patch('/agents/commissions/bulk-pay', data).then((r) => r.data);

export const getSettlementSummary = () =>
  API.get('/agents/settlement-summary').then((r) => r.data);

export const deleteAgent = (id) =>
  API.delete(`/agents/${id}`).then((r) => r.data);
